import { Component, Inject, NgZone, ViewEncapsulation } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { EncryptDecryptService } from 'src/app/core/services/encrypt-decrypt.service';
import { CommonFunctions } from 'src/app/shared/common-functions';
declare var dataLayer;
@Component({
  selector: 'app-reward-activity-dialog',
  templateUrl: './reward-activity-dialog.component.html',
  styleUrls: ['./reward-activity-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RewardActivityDialogComponent{
  public tierDetails: any;
  public recentActivities = [];
  public loader: boolean = false;
  userType: string;
  userId: any;
  tierType: any;
  constructor(private _bottomSheet: MatBottomSheet, @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,private encryptDecryptService : EncryptDecryptService,
    private ngzone: NgZone,private commonFunction: CommonFunctions) {
    this.tierDetails = JSON.parse(localStorage.getItem('user_profile'));
    this.tierDetails.anniverSaryDate = this.tierDetails.anniverSaryDate != null ? this.encryptDecryptService.decryptData(this.tierDetails.anniverSaryDate) : '';
    this.tierDetails.currentStarBalance = this.tierDetails.currentStarBalance != null ? this.encryptDecryptService.decryptData(this.tierDetails.currentStarBalance) : 0;
    this.tierDetails.dateOfBirth = this.tierDetails.dateOfBirth != null ? this.encryptDecryptService.decryptData(this.tierDetails.dateOfBirth) : '';
    this.tierDetails.emailId = this.tierDetails.emailId != null ? this.encryptDecryptService.decryptData(this.tierDetails.emailId): '';
    this.tierDetails.mobileNumber = this.tierDetails.mobileNumber != null ? this.encryptDecryptService.decryptData(this.tierDetails.mobileNumber) : '';
    this.tierDetails.referralCode = this.tierDetails.referralCode != null ? this.encryptDecryptService.decryptData(this.tierDetails.referralCode) : this.tierDetails.referralCode;
    this.tierDetails.rewardCount = this.tierDetails.rewardCount != null ? this.encryptDecryptService.decryptData(this.tierDetails.rewardCount) :0 ;
    this.tierDetails.starBalance = this.tierDetails.starBalance != null ? this.encryptDecryptService.decryptData(this.tierDetails.starBalance) : 0;
    this.tierDetails.starEarned = this.tierDetails.starEarned !=null ? this.encryptDecryptService.decryptData(this.tierDetails.starEarned) : 0;
    this.tierDetails.tier = this.tierDetails.tier != null ? this.encryptDecryptService.decryptData(this.tierDetails.tier) : 'welcome';
    this.tierDetails.tierUpperLimit = this.tierDetails.tierUpperLimit != null ? this.encryptDecryptService.decryptData(this.tierDetails.tierUpperLimit) : 0;
    this.tierDetails.totalCardBalance = this.tierDetails.totalCardBalance != null ? this.encryptDecryptService.decryptData(this.tierDetails.totalCardBalance) : 0;
    this.tierDetails.totalMsrCardBalance = this.tierDetails.totalMsrCardBalance != null ? this.encryptDecryptService.decryptData(this.tierDetails.totalMsrCardBalance) : 0;
    this.recentActivities  = JSON.parse(localStorage.getItem('reward-activities'));
    this.filterData();
    this.userType = this.commonFunction.getUserType();
    this.userId = this.commonFunction.getUserId();
    this.tierType = this.commonFunction.getTierType();
  }
  closeSheet() {
    this._bottomSheet.dismiss()
  }
  filteredData = [];
  public filterData() {
    let data = this.recentActivities;
    this.ngzone.runOutsideAngular(() => {
      let monthRepeated: string = null;
      data.forEach((item) => {
        monthRepeated = item.rewardStartdate.substring(5, 7);;
        const itemIndex = this.filteredData
          .findIndex((i) =>
            i.date === monthRepeated);
        // if same date
        if (itemIndex > -1) {
          this.filteredData[itemIndex]
            .list
            .push(
              item
            );
          return;
        }
        // If date is not matching
        this.filteredData.push({
          date: monthRepeated,
          list: [
            item
          ],
        });
      });
    });
    this.replaceMonth();
  }
  public replaceMonth() {
    let month = [
      { monthNumber: '01', monthText: 'January' },
      { monthNumber: '02', monthText: 'Febuary' },
      { monthNumber: '03', monthText: 'March' },
      { monthNumber: '04', monthText: 'April' },
      { monthNumber: '05', monthText: 'May' },
      { monthNumber: '06', monthText: 'June' },
      { monthNumber: '07', monthText: 'July' },
      { monthNumber: '08', monthText: 'August' },
      { monthNumber: '09', monthText: 'September' },
      { monthNumber: '10', monthText: 'October' },
      { monthNumber: '11', monthText: 'November' },
      { monthNumber: '12', monthText: 'December' },
    ]
    for (let item of this.filteredData) {
      var solution = month.filter(obj => obj.monthNumber == item.date);
      item.date = solution[0]['monthText'];
    }
  }
  crossBtnGA(){
    dataLayer.push({
      'event':'cross_click',
      'userID':this.userId,
      'user_type':this.userType,
      'tier':this.tierType
    })
  }
}
